import { render, staticRenderFns } from "./TikQAlignmentComponent.vue?vue&type=template&id=7e26eb19&scoped=true&"
import script from "./TikQAlignmentComponent.vue?vue&type=script&lang=js&"
export * from "./TikQAlignmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./TikQAlignmentComponent.vue?vue&type=style&index=0&id=7e26eb19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e26eb19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
